import { Injectable } from "@angular/core";
import { PassportsStore } from "types";

@Injectable()
export class PassportsStoreImpl extends PassportsStore {
}
